/**
 * Simple print page controller 
 */

'use strict';

(() => {
  angular
    .module('specsguardApp')
    .controller('sgPrintPageController', sgPrintPageController); 

  sgPrintPageController.$inject = ['$window'];

  function sgPrintPageController ($window) {

    const vm = this; 

    vm.print = () => {
      $window.print();
    };

  };

})();